var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLokalgrowPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#0b1f12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C5.515 1.5 3.5 3.515 3.5 6C3.5 8.1 4.9 9.9 6.9 10.5L8 14.5L9.1 10.5C11.1 9.9 12.5 8.1 12.5 6C12.5 3.515 10.485 1.5 8 1.5Z",
    fill: "#2ecc71"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1.5,
    fill: "#0b1f12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokalgrowPin);
export default __webpack_public_path__ + "static/media/lokalgrow-pin.3d5fb91d2c91e7eaf8b6dcddc6b96888.svg";
export { ForwardRef as ReactComponent };